
import { prop, Vue } from "vue-class-component";

class Props {
  fill = prop<boolean>({
    default: false,
    type: Boolean,
  });
}
export default class Amercement extends Vue.with(Props) {}
